import * as React from 'react';
export default function SvgPhotoshop() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 7.75a3 3 0 013-3h8.5a3 3 0 013 3v8.5a3 3 0 01-3 3h-8.5a3 3 0 01-3-3v-8.5z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.755 16.25h1.593a.9.9 0 00.85-1.194c-.075-.215-.3-.321-.525-.36l-1.322-.223c-.224-.038-.447-.145-.532-.356-.248-.62.194-1.367.933-1.367h1.502M7.75 16.25v-4m0 0v-3.5H9.5a1.75 1.75 0 110 3.5H7.75z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}